import { render, staticRenderFns } from "./judicalActModal.vue?vue&type=template&id=3e5777fe&"
import script from "./judicalActModal.vue?vue&type=script&lang=js&"
export * from "./judicalActModal.vue?vue&type=script&lang=js&"
import style0 from "./judicalActModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports